import PropTypes from 'prop-types';
import { useState } from 'react';
import { Box, Tooltip, IconButton, Menu, MenuItem } from '@mui/material';
import {
    DarkMode,
    LightMode,
    SettingsBrightness,
} from '@mui/icons-material';
import { useThemeMode } from '../../../contexts/ThemeModeContext';

export function ThemeToggleMenu({ showTransparent }) {
    const { preference, resolvedMode, setPreference } = useThemeMode();
    const [themeAnchorEl, setThemeAnchorEl] = useState(null);
    const isThemeMenuOpen = Boolean(themeAnchorEl);

    const handleSelectPreference = (pref) => {
        setPreference(pref);
        setThemeAnchorEl(null);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
            <Tooltip title="Theme options" arrow>
                <IconButton
                    onClick={(e) => setThemeAnchorEl(e.currentTarget)}
                    aria-label="Theme Mode Selection"
                    aria-controls={isThemeMenuOpen ? 'theme-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={isThemeMenuOpen ? 'true' : undefined}
                    size="small"
                    sx={{ color: showTransparent ? 'white' : 'text.primary' }}
                >
                    {resolvedMode === 'dark' ? <DarkMode fontSize="small" /> : <LightMode fontSize="small" />}
                </IconButton>
            </Tooltip>
            <Menu
                id="theme-menu"
                anchorEl={themeAnchorEl}
                open={isThemeMenuOpen}
                onClose={() => setThemeAnchorEl(null)}
                slotProps={{ menuList: { 'aria-label': 'Theme options' } }}
            >
                <MenuItem
                    selected={preference === 'system'}
                    onClick={() => handleSelectPreference('system')}
                    sx={{ gap: 1.5, fontSize: '0.9rem' }}
                >
                    <SettingsBrightness fontSize="small" /> System
                </MenuItem>
                <MenuItem
                    selected={preference === 'light'}
                    onClick={() => handleSelectPreference('light')}
                    sx={{ gap: 1.5, fontSize: '0.9rem' }}
                >
                    <LightMode fontSize="small" sx={{ color: 'warning.main' }} /> Light
                </MenuItem>
                <MenuItem
                    selected={preference === 'dark'}
                    onClick={() => handleSelectPreference('dark')}
                    sx={{ gap: 1.5, fontSize: '0.9rem' }}
                >
                    <DarkMode fontSize="small" sx={{ color: 'primary.light' }} /> Dark
                </MenuItem>
            </Menu>
        </Box>
    );
}

ThemeToggleMenu.propTypes = {
    showTransparent: PropTypes.bool,
};

export default ThemeToggleMenu;
